"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _checkbox = _interopRequireDefault(require("./checkbox.css"));

var _span;

var Input = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(Input, _React$PureComponent);

  function Input(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.state = {
      checked: Boolean(props.defaultValue)
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = Input.prototype;

  _proto.handleChange = function handleChange(event) {
    var onChange = this.props.onChange;
    var checked = event.target.checked;
    this.setState({
      checked: checked
    });
    onChange(event);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        testID = _this$props['data-testid'],
        id = _this$props.id,
        label = _this$props.label,
        name = _this$props.name;
    var checked = this.state.checked;

    var inputNode = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
      "data-testid": testID,
      id: id || name,
      type: "checkbox",
      name: name,
      onChange: this.handleChange,
      checked: checked
    }), _span || (_span = /*#__PURE__*/_react["default"].createElement("span", {
      className: "tick"
    })));

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(_checkbox["default"].checkbox, 'checkbox-wrapper', className)
    }, label ? /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: id || name
    }, inputNode, /*#__PURE__*/_react["default"].createElement("span", {
      className: _checkbox["default"].label
    }, label)) : inputNode);
  };

  return Input;
}(_react["default"].PureComponent);

exports["default"] = Input;
Input.defaultProps = {
  onChange: function onChange() {
    return undefined;
  }
};